import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MoveSandbox } from '@app/move/sandboxes/move.sandbox';

@Component({
    selector: 'app-ots-container',
    template: ` <router-outlet></router-outlet> `,
})
export class OtsContainerContainer implements OnDestroy {
    constructor(private readonly moveSandbox: MoveSandbox, private readonly router: Router) {}

    public ngOnDestroy(): void {
        // clear move state before we leave the ots flow
        this.moveSandbox.clearMoveState();
    }
}
